import { memo, useState } from 'react';
import { Link as ScrollLink } from 'react-scroll';

import Stack from '@mui/material/Stack';

import CustomNavList from './CustomNavList';
import { useNavScroll } from '../hooks/useNavScroll';

import type { NavProps, NavGroupProps } from '../types';

const EnhancedScrollLink = ScrollLink as React.ComponentType<any>;


// ----------------------------------------------------------------------

function CustomNavSectionMini({ data, slotProps, ...other }: NavProps) {
  const [activeSection, setActiveSection] = useState(window.location.hash.slice(1));

  return (
    <Stack component="nav" id="nav-section-mini" spacing={`${slotProps?.gap || 4}px`} {...other}>
      {data.map((group, index) => (
        <CustomGroup
          key={group.subheader || index}
          items={group.items}
          slotProps={{ ...slotProps, activeSection }}
          onSetActive={setActiveSection}
        />
      ))}
    </Stack>
  );
}

export default memo(CustomNavSectionMini);
// ----------------------------------------------------------------------

function CustomGroup({
  items,
  slotProps,
  onSetActive,
}: NavGroupProps & { onSetActive: (id: string) => void }) {
  const { disableSpy, handleClick, handleSetActive } = useNavScroll(onSetActive);

  return (
    <>
      {items.map((list) =>
        slotProps?.scrollNav ? (
          <EnhancedScrollLink
            key={list.title}
            to={list.path}
            data-testid={`nav-${list.path}`}
            spy={!disableSpy}
            offset={-80}
            smooth
            duration={550}
            onClick={() => handleClick(list.path)}
            onSetActive={() => handleSetActive(list.path)}
          >
            <CustomNavList data={list} depth={1} slotProps={slotProps} />
          </EnhancedScrollLink>
        ) : (
          <CustomNavList key={list.title} data={list} depth={1} slotProps={slotProps} />
        )
      )}
    </>
  );
}
